
import { schema } from "./types";
import { IAutomationAppComponent } from "../../../types";
import { OverviewPanel, OperatorPanel, ParameterPanel } from './';
import { IconCooling } from './IconCooling';
import InsightsPanel from "../../components/PlantInsights/InsightsPanel";
import InsightsSideviewPanel from "../../components/PlantInsights/InsightsSideviewPanel";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: IconCooling,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ParameterPanel: ParameterPanel,
    InsightsPanel: InsightsPanel,
    SideViewPanel: InsightsSideviewPanel,
    createConfig:      {
        group: "Plants",
        name: "A cooling outlet",
        description: "Cooling outlet",
        panel: OverviewPanel,
        defaultState: {  showFlow: 'true', showTrendPanels: 'true' },
        defaultProperties: [
            { key: 'ShowFlow', value: 'true' },
            { key: 'ShowTrendPanels', value: 'true' },
        ]
    },
}